export default __webpack_public_path__ + "static/media/drag-drop.7716476b.svg";